/**
 * Route guard: renders an explicit access-denied screen instead of its
 * children when the current account lacks a required permission, rather than
 * silently bouncing back to the overview.
 *
 * @module router/RequirePermission
 */

import React from "react";

import { Navigate, useLocation } from "react-router";

export function RequirePermission({ ok, children }: { ok: boolean; children: React.ReactNode }) {
  const location = useLocation();
  if (!ok) {
    return <Navigate to="/access-denied" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
